<template>
    <div>
        <!-- :on-icon-click="onIconClick" -->
        <el-input
            ref="input"
            :value="value"
            :disabled="disabled"
            :placeholder="placeholder"
            :name="name"
            :size="size"
            :suffix-icon="icon"
            :style="{width: width}"
            @input="handleChange"
            @focus="handleFocus"
            @blur="handleBlur"
            @keydown.enter.native.prevent="handleBlur"
            @keydown.up.native.prevent="highlight(highlightedIndex - 1)"
            @keydown.down.native.prevent="highlight(highlightedIndex + 1)">
        </el-input>
        <ly-suggestions
            ref="suggestions"
            :suggestions="suggestions"
            :dropdown-width="dropdownWidth"
            :show-popperr="showPopper"
            :highlighted-index="highlightedIndex"
            :dropdown-fields="dropdownFields"
            @change="suggestionsChange">
        </ly-suggestions>
    </div>
</template>
<script>
    import LySuggestions from './suggestions.vue'
    import Emitter from 'element-ui/src/mixins/emitter'
    export default {
        name: 'LyAutoInput',
        mixins: [Emitter],
        components: {
            LySuggestions
        },
        props: {
            placeholder: String,
            disabled: Boolean,
            name: String,
            size: {
                type: String,
                default: 'small'
            },
            value: [String, Number],
            // autofocus: Boolean,
            fetchSuggestions: Function,
            triggerOnFocus: {
                type: Boolean,
                default: true
            }, // 标识，是否在获取焦点的时候 显示提示面板
            icon: String,
            onIconClick: Function,
            width: {
                type: String,
                default: '220px'
            }, // 输入框面板的宽度
            dropdownWidth: String, // 结果提示面板的宽度
            dropdownFields: Array, // 下拉提示面板所显示的字段配置
            isInitSearch: { // 标识是否初始就进行数据的获取
                type: Boolean, 
                default: false
            }
        },
        data () {
            return {
                isFocus: false,
                isOnComposition: false,
                suggestions: [], // 提示面板的数据结果
                loading: false,
                highlightedIndex: -1, // 当前高亮行的索引
                showPopper: false,
                currInputTimer: 0, // 记录输入框当前输入的时间
                dateTimeout: null // 获取数据的定时器
            }
        },
        mounted () {
            if (this.isInitSearch) {
                this.handleBlur()
                this.getData('')
            }
        },
        methods: {
            getData (keyword) {
                this.loading = true 
                this.showPopper = true
                if (this.dateTimeout) {
                    clearTimeout(this.dateTimeout)
                }
                // 数据的获取
                this.dateTimeout = setTimeout(() => {                   
                    this.fetchSuggestions(keyword, (suggestions) => {
                        this.loading = false
                        if (Array.isArray(suggestions)) {
                            this.suggestions = suggestions
                        } else {
                            console.error('autoinput的数据must be an array');
                        }
                    })
                }, 200)
            },
            handleChange (value) {
                this.$emit('input', value)
                if (this.isOnComposition || (!this.triggerOnFocus && !value)) {
                    this.suggestions = []
                    return
                }
                this.getData(value)
            },
            handleFocus () {
                this.isFocus = true
                if (this.suggestions.length > 0) { // 若有数据，获得焦点时，显示结果面板
                    this.showPopper = true
                }
                this.$emit('focus')
            },
            handleBlur () {
                // 因为 blur 事件处理优先于 select 事件执行
                setTimeout(_ => {
                    this.isFocus = false
                    this.showPopper = false
                }, 100)
            },
            highlight (index) {
                if (index < 0) index = 0
                if (this.suggestions.length < 1) {
                    return
                } 
                if (index >= this.suggestions.length) {
                    index = this.suggestions.length - 1
                }
                // 表格跟随滚动
                const suggestion = this.$refs.suggestions.$el.querySelector('.el-table__body-wrapper')
                const suggestionList = suggestion.querySelectorAll('tr')
                let highlightItem = suggestionList[index]
                let scrollTop = suggestion.scrollTop
                let offsetTop = highlightItem.offsetTop
                if (offsetTop + highlightItem.scrollHeight > (scrollTop + suggestion.clientHeight)) {
                    suggestion.scrollTop += highlightItem.scrollHeight
                }
                if (offsetTop < scrollTop) {
                    suggestion.scrollTop -= highlightItem.scrollHeight
                }
                this.highlightedIndex = index;
                // 反馈当前高亮下的对象
                this.suggestionsChange(this.suggestions[index])
            },
            /**
             * 提示面板内容的选择监听
             * @return 
             */
            suggestionsChange (row) {
                // 这里将row克隆一次，在关联数据中不然存在问题
                let data = this.$utils.deepClone(row)
                this.$emit('change', data)
            }
        },
        beforeDestroy () {
            this.$refs.suggestions.$destroy()
        }
    }
</script>